<div class="multi-step-form min-vh-100 d-flex flex-column">
    <div class="d-flex justify-content-end align-items-center mt-2 px-3">
        <button class="btn btn-sm border-0 rounded bg-transparent d-flex align-items-center fw-bold text-white">
            <i class="bi bi-box-arrow-right fs-4 icon-white me-2"></i>
            <a href="/" class="text-xs text-white text-decoration-none"></a>
        </button>
    </div>

    <div class="forms-container d-flex justify-content-center pt-4 px-3">
        <div class="w-65 col-xl-7 col-lg-8 col-md-10 col-12">
            <div class="form-header btn-primary-dark fw-bold text-x mt-2 mb-4 border-0">
                {{ title }}
            </div>
            <div class="card shadow-sm border-0">
                <div class="glassy-bg rounded-lg">

                    <div class="form-fields-container p-3">
                        <div class="mb-3">
                            <label class="text-xxs fw-bold">Review Platform Consent</label>
                            <div class="border rounded p-3 bg-light overflow-y-auto">
                                <p class="text-xxs mb-2">
                                    Welcome. 
                                    To continue, please confirm that you have read and agree to the
                                    terms governing the use of this platform, including data handling,
                                    security responsibilities, and acceptable use requirements.
                                </p>

                                <ul class="text-xxs ps-3 mb-2">
                                    <li>Your information will be processed in accordance with applicable privacy and data protection regulations.</li>
                                    <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                                    <li>Any documents or information submitted must be accurate, lawful, and authorised.</li>
                                    <li>Use of the platform must comply with the policies and agreements applicable to your organisation.</li>
                                    <li>Failure to comply with these terms may result in restricted or revoked access.</li>
                                </ul>

                            </div>
                        </div>
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" id="acknowledge_terms" v-model="acknowledged" />
                            <label class="form-check-label text-xxs" for="acknowledge_terms">
                                I have read and agreed to the Consent.
                            </label>
                        </div>
                        <div class="d-flex justify-content-end gap-2">
                            <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                                :disabled="verification_running || !acknowledged" @click.prevent="accept_terms">
                                Accept
                            </button>
                            <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" :disabled="verification_running"
                                @click.prevent="decline_terms">
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>